import React from 'react';

export const AboutCta = ({ onBook }) => (
  <section className="section-spacing bg-[#1a1a1a] text-center" data-testid="about-cta">
    <div className="revolt-container">
      <h2 className="section-title">Ready to Create Beautiful Memories?</h2>
      <p className="subtitle mb-lg max-w-2xl mx-auto">
        Let's work together to capture your family's precious moments
      </p>
      <button onClick={onBook} className="hero-cta" data-testid="about-cta-book-btn">
        Book a Session
      </button>
    </div>
  </section>
);
